export class PearlHarborSoundConfig {
    public static readonly MAIN_GAME_AMBIANCE:string = "background-music-main";
    public static readonly FS_AMBIANCE:string = "fsMain";


    public static readonly AS_WIN:string = "asWin";
    public static readonly AS_WIN_BIG:string = "asWinBig";

    public static readonly REELS_OUT:string = "reelsOut";
    public static readonly REELS_IN:string = "reelsIn";
    public static readonly LANDING_ALL:string = "reelLandingAll";
    public static readonly LANDING_FEW:string = "reelLandingFew";
    public static readonly LANDING_ONE:string = "reelLandingOne";
    public static readonly HIGHLIGHT:string = "betlineHighlight";

    public static readonly REEL_AREA_EXPAND:string = "reelAreaExpand";
    public static readonly REEL_AREA_SHRINK:string = "reelAreaShrink";

    public static readonly ENHANCE_BET_1:string = "xBetOn1";
    public static readonly ENHANCE_BET_2:string = "xBetOn2";
    public static readonly ENHANCE_BET_OFF:string = "xBetOff";

    public static readonly COUNT_UP:string = "countup";
    public static readonly COUNT_UP_END:string[] = ["winTiny", "winSmall", "winMedium", "winLarge"];

    public static readonly EXPLODE_TINY_SMALL:string = "betlineExplodeTinySmall";
    public static readonly EXPLODE_MEDIUM:string = "betlineExplodeMedium";
    public static readonly EXPLODE_LARGE:string = "betlineExplodeLarge";

    public static readonly TARGET_TO_WILD:string = "wild";
    public static readonly X_BOMB_LANDING:string = "xBombLanding";
    public static readonly X_BOMB_DROP:string = "xBombDrop";
    public static readonly MULTIPLIER_BOMB:string = "multiplierBomb";
    public static readonly MULTIPLIER_SCATTER:string = "multiplierScatter";

    public static readonly X_SPLIT_WILD:string = "xSplitWild";
    public static readonly X_SPLIT_SLICE:string[] = ["xSplitSlice", "xSplitSlice2"];

    public static readonly SCATTER_WIN:string = "scatterWin";
    public static readonly SCATTER_LANDING_IN:string = "scatterLandingInside";
    public static readonly SCATTER_LANDING_OUT:string = "scatterLandingOutside";

    public static readonly BIG_WIN_LEVELS:string[] = ["bigwinLevel1", "bigwinLevel2", "bigwinLevel3"];
    public static readonly BIG_WIN_END:string = "bigwinEnds";

    public static readonly FS_INTRO:string = "fsIntro";
    public static readonly FS_LOOP:string = "fsMusicLoop1";
    public static readonly FS_DOGFIGHT:string = "fsMusicLoop2";
    public static readonly FS_BOMB_ATTACK:string = "fsMusicLoop3";
    public static readonly CONTINUE_BUTTON:string = "continueButton";
    public static readonly SPLASH:string = "splash";

    public static readonly CAP_WIN_START:string = "capWinStart";
    public static readonly CAP_WIN_MUSIC:string = "capWinMusic";
    public static readonly CAP_WIN_END:string = "capWinEnds";

    public static readonly FS_SWOOSH:string = "fsMeter1";
    public static readonly FS_ROUND_NUMBER_ADD:string = "fsMeter2";
    public static readonly FS_COLUMN_ON:string = "fsMeter3";
    public static readonly FS_ROW_ON:string = "fsMeter3";
    public static readonly FS_ADD_TO_TOTAL:string = "fsMeter4";
    public static readonly FS_MISS_NUMBER:string = "fsMeter5";
    public static readonly FS_SPREAD:string = "fsMeter6";
    public static readonly FS_TOTAL_MUL_ENDING:string = "fsMeter7";
    public static readonly FS_HIT:string[] = ["fsHit_1", "fsHit_2", "fsHit_3", "fsHit_4"];

    public static readonly FS_BOMB_ATTACK_ANIMATION:string = "fsBombAttack";
    public static readonly FS_BA_HIT:string = "fsBombAttackHit";
    public static readonly FS_BA_MISS:string = "fsBombAttackMiss";

    public static readonly FS_DOGFIGHT_PLANE:string[] = ["dogfightPlaneUp", "dogfightPlaneDown", "dogfightPlaneLeft", "dogfightPlaneRight"];
    public static readonly FS_DOGFIGHT_HIT:string = "dogfightHit";

    public static readonly FS_KAMIKAZE:string = "kamikaze";
    public static readonly FS_KAMIKAZE_HIT:string = "kamikazeHit";
    public static readonly FS_KAMIKAZE_MISS:string = "kamikazeMiss";

    public static readonly FS_SPIN:string = "fsSpin";
    public static readonly FS_SPIN_STOP:string = "fsSpinStop";
    public static readonly FS_SPIN_START:string[] = ["fsSpin1", "fsSpin2", "fsSpin3"];
    public static readonly FS_SPIN_START_FAST:string[] = ["fsSpin1Fast", "fsSpin2Fast", "fsSpin3Fast"];
    public static readonly FS_SPIN_END:string[] = ["fsSpin1Ends", "fsSpin2Ends", "fsSpin3Ends"];
    public static readonly FS_SPIN_HIT:string[] = ["fsHitSingle1", "fsHitSingle2", "fsHitSingle3", "fsHitMany"];

    public static readonly FS_OUTRO_FADE_IN:string = "fsOutroFadein";
    public static readonly FS_OUTRO_MEDAL:string[] = ["fsOutroMedal0", "fsOutroMedal1", "fsOutroMedal2", "fsOutroMedal3", "fsOutroMedal4"];
}